import React from "react";
import plantMan1 from "../assets/man-florist-working-green-house 1.png"
import plantMan2 from "../assets/man-florist-working-green-house 2.png"
import plantMan3 from "../assets/man-florist-working-green-house 3.png"
import HerbIcon from "./herb_icon";
import PlantBottleIcon from "./plant_bottle_icon";
import FertilizerIcon from "./fertilizer_icon";
import LimestoneIcon from "./limestone_icon";
import SaltIcon from "./salt_icon";
import OilIcon from "./oil_icon";

const Body45 = (props) => {
    return (
        <div className="flex items-center text-center justify-center"{...props}>
            <div className="
            mt-72
            mb-113
            mobile:mt-72 mobile:mb-113
            mobileXl:mt-72 mobileXl:mb-113
            tablet:mt-[350px] tablet:mb-[72px]
            max-w-[770px]" id="insumos">
                <p className="
                  text-[39px] mt-[-140px] font-black tracking-wide text-mediumGreen text-left
                  tablet:mt-0 tablet:text-[60px]
                ">SOLUÇÕES AGRÍCOLAS</p>
            </div>
            <div>
                <p  className=" text-[18px] font-light tracking-wide text-lettertext text-left leading-10 mb-[138px] 
                tablet:mb-[72px] tablet:text-[23px] max-w-[505px]">
                    <span className="font-bold">Com o crédito obtido </span>, você poderá adquirir uma variedade de <span className="font-bold">insumos, equipamentos</span> e até mesmo
                    <span className="font-bold"> liquidar seus impostos. <br/></span> 
                    <span className="font-bold">Convertendo o crédito em receita </span><span>para a atividade do produtor rural.</span>
                </p>
            </div>
            <div className="bg-lightBrown h-[375px] py-[30px] px-16 tablet:px-32 rounded-[26px]">
                <p className="text-white  mx-[16px] text-left text-[18px] font-light tracking-wide mb-[30px] hidden 
                tablet:block tablet:text-[23px]">Agronegócio fácil com 
                    <span className="font-extrabold"> aquisição de insumos:</span>
                </p>
                <div className="flex flex-col gap-[32px] justify-center items-center text-[24px] font-medium mx-0
                tablet:flex-wrap tablet:flex-row tablet:flex-grow tablet:justify-left w-[610px]">
                    <div className="h-[58px] bg-fafafa rounded-full flex justify-start items-center
                    tablet:w-[320px] tabletL:w-[250px]">
                        <div className="px-[10px]"><HerbIcon/></div>
                        <p>Herbicidas</p>
                    </div>
                    <div className="h-[58px] bg-fafafa rounded-full flex justify-start items-center
                    tablet:w-[320px] tabletL:w-[250px]">
                        <div className="px-[10px]"><PlantBottleIcon/></div>
                        <p>Fertilizantes</p>
                    </div>
                    <div className="h-[58px] bg-fafafa rounded-full flex justify-start items-center
                    tablet:w-[320px] tabletL:w-[250px]">
                        <div className="px-[10px]"><FertilizerIcon/></div>
                        <p>Adubos</p>
                    </div>
                    <div className="h-[58px] bg-fafafa rounded-full flex justify-start items-center
                    tablet:w-[320px] tabletL:w-[250px]">
                        <div className="px-[10px]"><LimestoneIcon/></div>
                        <p>Calcário</p>
                    </div>
                    <div className="h-[58px] bg-fafafa rounded-full flex justify-start items-center
                    tablet:w-[320px] tabletL:w-[250px]">
                        <div className="px-[10px]"><SaltIcon/></div>
                        <p>Sal</p>
                    </div>
                    <div className="h-[58px] bg-fafafa rounded-full flex justify-start items-center
                    tablet:w-[320px] tabletL:w-[250px]">
                        <div className="px-[10px]"><OilIcon/></div>
                        <p>Óleo diesel</p>
                    </div>
                </div>
            </div>
                <div className="col-span-full relative mr-[-200px] mt-[-980px] z-0 flex justify-end overflow-hidden
                ">
                    <img className="mobileXl:hidden z-0 
                    " src={plantMan1} alt=''/>
                    <img className="hidden mobileXl:block tablet:hidden z-0" src={plantMan2} alt=''/>
                    <img className="hidden mobileXl:hidden tablet:block z-0 scale-[0.95]" src={plantMan3} alt=''/>
                </div>
        </div>
    )
}

export default Body45